export default {"id":"icon-select-filter"}